<template>
  <aha-modal
    @hide="hide()"
    :title="title"
    action-position="justify-end"
  >
    <span class="block mb-3">{{ warningMessage }}:</span>
    <a class="text-hyper-link" :href="url" target="_blank">{{ url }}</a>
    <template #action>
      <aha-button variant="base" @click="hide()">
        <span class="font-bold">{{ $i18nPresenter.t("Cancel") }}</span>
      </aha-button>
    </template>
  </aha-modal>
</template>
<script>
export default {
  props: {
    url: {
      type: String,
      default: '',
    },
  },
  computed: {
    title() {
      return this.$i18nPresenter.t('Leaving Ahaslides.com')
    },
    warningMessage() {
      return this.$i18nPresenter.t('The link you are visiting is not from our website. Click to continue to')
    },
  },
  methods: {
    hide() {
      this.$emit('hide')
    },
  },
}
</script>
